/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-08-14 09:59:22
 * @LastEditors: linxi
 * @LastEditTime: 2024-04-19 11:04:46
 */
import { BillingCategoryName } from './billingCategory'

//医生核算明细打印单
export function printDoctorAuditBody(data: any) {
  const tenantName = data?.tenantName
  const timeHead = data?.timeHead
  const timeTail = data?.timeTail
  const CKLRSJData = data?.CKLRSJData
  const drugType = data?.drugType // 0 药品，1 诊疗
  const datas = data?.dataList || []
  const all = data?.total || {}

  const columns: any[] =
    drugType == 1
      ? [
          { title: '项目名称', width: '14%', render: (r: any) => r?.name ?? '' },
          { title: '单位', width: '8%', render: (r: any) => r?.accountUnit ?? '' },
          { title: '开单医生', width: '10%', render: (r: any) => r?.treatmentDoctorName ?? '' },
          { title: '数量', width: '8%', render: (r: any) => r?.totalCount ?? '' },
          { title: '零售金额', width: '12%', render: (r: any) => r?.totalRetail?.toFixed(2) ?? '' },
          { title: '实收金额', width: '12%', render: (r: any) => r?.estimateRealPayAmount?.toFixed(2) ?? '' },
          { title: '进货金额', width: '12%', render: (r: any) => (!CKLRSJData ? '***' : (r?.totalCost?.toFixed(2) ?? '')) },
          { title: '利润率', width: '12%', render: (r: any) => (!CKLRSJData ? '***' : (r?.profitRate?.toFixed(2) ?? '')) },
          { title: '利润', width: '12%', render: (r: any) => (!CKLRSJData ? '***' : (r?.totalDiff?.toFixed(2) ?? '')) },
        ]
      : [
          { title: '项目名称', width: '13%', render: (r: any) => r?.name ?? '' },
          { title: '规格', width: '9%', render: (r: any) => r?.packSpec ?? '' },
          { title: '供应商', width: '9%', render: (r: any) => r?.gysName ?? '' },
          { title: '厂家', width: '9%', render: (r: any) => r?.tenantSupplierName ?? '' },
          { title: '批次', width: '5%', render: (r: any) => (r?.batchNo ? r.batchNo : '-') },
          { title: '开票项目', width: '6%', render: (r: any) => BillingCategoryName(r?.billingCategory) },
          { title: '单位', width: '4%', render: (r: any) => r?.accountUnit ?? '' },
          { title: '开单医生', width: '7%', render: (r: any) => r?.treatmentDoctorName ?? '' },
          { title: '数量', width: '4%', render: (r: any) => r?.totalCount ?? '' },
          { title: '零售金额', width: '7%', render: (r: any) => r?.totalRetail?.toFixed(2) ?? '' },
          { title: '实收金额', width: '8%', render: (r: any) => r?.estimateRealPayAmount?.toFixed(2) ?? '' },
          { title: '进货金额', width: '7%', render: (r: any) => (!CKLRSJData ? '***' : (r?.totalCost?.toFixed(2) ?? '')) },
          { title: '利润率', width: '6%', render: (r: any) => (!CKLRSJData ? '***' : (r?.profitRate?.toFixed(2) ?? '')) },
          { title: '利润', width: '6%', render: (r: any) => (!CKLRSJData ? '***' : (r?.totalDiff?.toFixed(2) ?? '')) },
        ]

  // 合计行各列值（与 columns 顺序对应）
  const totalValues: any[] =
    drugType == 1
      ? [
          '合计',
          '',
          '',
          all?.totalCount ?? '',
          all?.totalRetail?.toFixed(2) ?? '',
          all?.estimateTotalRealPayAmount?.toFixed(2) ?? '',
          !CKLRSJData ? '***' : (all?.pageTotalCost ?? ''),
          !CKLRSJData ? '***' : (all?.pageTotalProfitRate ?? ''),
          !CKLRSJData ? '***' : (all?.pageTotalDiff ?? ''),
        ]
      : [
          '合计',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          all?.pageTotalCount ?? '',
          all?.pageTotalRetail ?? '',
          all?.pageEstimateTotalRealPayAmount ?? '',
          !CKLRSJData ? '***' : (all?.pageTotalCost ?? ''),
          !CKLRSJData ? '***' : (all?.pageTotalProfitRate ?? ''),
          !CKLRSJData ? '***' : (all?.pageTotalDiff ?? ''),
        ]

  const cell = (value: any, w: string, isLast: boolean) =>
    `<div style="line-height:25px;padding-left:2px;padding-right:2px;word-break:break-all;width:${w};text-align:center;box-sizing:border-box;${isLast ? '' : 'border-right:1px solid #000'}">${value}</div>`

  const headerHtml = columns
    .map((c, i) => cell(c.title, c.width, i === columns.length - 1))
    .join('')

  let rowHtml = ''
  for (const r of datas) {
    const cells = columns
      .map((c, i) => cell(c.render(r), c.width, i === columns.length - 1))
      .join('')
    rowHtml +=
      `<div style="min-height:28px;font-size:13px;display:flex;clear:left;border-left:1px solid #000;border-right:1px solid #000;border-bottom:1px solid #000">` +
      cells +
      '</div>'
  }

  // 合计行
  const totalCells = columns
    .map((c, i) => cell(totalValues[i] ?? '', c.width, i === columns.length - 1))
    .join('')
  rowHtml +=
    `<div style="min-height:28px;font-size:13px;display:flex;clear:left;border-left:1px solid #000;border-right:1px solid #000;border-bottom:1px solid #000">` +
    totalCells +
    '</div>'

  const timeHeadText = (timeHead || '').toString().split(' ')[0]
  const timeTailText = (timeTail || '').toString().split(' ')[0]

  const content =
    '<div style="margin-left:10px;margin-right:10px">' +
    `<h3 style="text-align:center;margin-bottom:5px;">${tenantName}</h3>` +
    '<h3 style="text-align:center;margin-top:5px;margin-bottom:5px;">医&nbsp;&nbsp;生&nbsp;&nbsp;核&nbsp;&nbsp;算&nbsp;&nbsp;明&nbsp;&nbsp;细</h3>' +
    '<div style="font-size:14px;display:flex;text-align:left;margin-bottom:6px">' +
    `<div style="font-size:14px;width:100%;padding-left:10px;display:flex;justify-content:flex-end;">日期:<font style="font-size:14px;word-break:break-all;padding-left:10px">${timeHeadText}至${timeTailText}</font></div>` +
    '</div>' +
    `<div style="font-weight:bold;min-height:25px;line-height:25px;font-size:14px;display:flex;clear:left;border:1px solid #000">${headerHtml}</div>` +
    rowHtml +
    '</div>'

  return content
}
